export const REFUND_TYPES = {
  NONE: '-1',
  REFUND: '0',
  CREDITS: '1'
}
